export function clearCanvas (canvasRef: React.RefObject<HTMLCanvasElement>) {
  const canvasContext = canvasRef.current?.getContext('2d')
  if (canvasContext) {
    const canvasEl = canvasContext.canvas
    canvasContext.clearRect(0, 0, canvasEl.width, canvasEl.height)
  }
}
